module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-progress', {
    attrs: {
      "value": 50,
      "bar-height": 5
    }
  }, [_c('div', {
    slot: "end"
  }, [_vm._v("Progress")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5988fc00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/mint-ui/Progress.vue
// module id = 554
// module chunks = 1